import MenuOptionsVisibility from 'redux/menu/types/menuOptionsVisibility';
import MENU_OPTIONS_ARRAY from 'redux/menu/configs/menuOptionsArray';

const isIncludesVisible = (visibility: MenuOptionsVisibility): boolean =>
  MENU_OPTIONS_ARRAY.some((item) => visibility[item]);

export default isIncludesVisible;
